import { OnInit, Input, Output, Component, EventEmitter } from '@angular/core';
import { LoaderService } from '../../../infrastructure/services/loader.service';

@Component({
  selector: 'sx-input',
  templateUrl: './input.component.html',
  styleUrls: ['./formWidgets.css'],
})
export class InputComponent implements OnInit {
  // Texto inicial
  @Input() texto: string;
  @Input() deshabilitado: string;
  @Input() placeholder: string;

  // Evento cuando el usuario acepta el cambio del texto
  @Output() textoCambiado: EventEmitter<string> = new EventEmitter();

  textoLocal: string;
  editando = false;
  error: string = null;

  ngOnInit() {
    this.textoLocal = this.texto;
  }

  confirmarEdicion() {
    if (!this.validarDescripcion(this.textoLocal, this.error)) {
      return;
    }

    this.textoCambiado.emit(this.textoLocal);
    this.editando = false;
    this.error = null;
  }

  deshacerEdicion() {
    this.textoLocal = this.texto;
    this.editando = false;
    this.error = null;
  }

  /**
   * Validaciones para la descripción
   *
   * @param valor El valor que será validado
   */
  private validarDescripcion(valor: string, error?: string) {
    if (!valor || valor.length <= 0) {
      this.error = 'VALOR_REQUERIDO';
      return false;
    }

    if (valor.length > 80) {
      this.error = 'Debe tener como máximo 80 caracteres.';
      return false;
    }

    return true;
  };
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/formWidgets/input.component.ts